import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  inject,
} from '@angular/core';
import { isDefined } from '@sama/js-core';
import { map } from 'rxjs/operators';
import { TaskWorkspaceStore } from '../../../../../../../core/h3ml/state/task-workspace-store';
import { SelectionService } from '../../../../../../../core/outputs/annotation/annotation-shared/utils/selection.service';
import { ObjectScopingService } from '../../../../../../../core/shared/misc-services/object-scoping.service';
import { ObjectDragAndDropService } from '../object-drag-and-drop.service';

@Component({
  selector: 'h3-unscope-object-button',
  templateUrl: './unscope-object-button.component.html',
  styleUrls: ['./unscope-object-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UnscopeObjectButtonComponent {
  scopedObjectId$ = this.taskWorkspaceStore('scopedObjectId').$;
  hasScopedObjectId$ = this.scopedObjectId$.pipe(map(isDefined));
  isNestingTarget$ = this.objectDragAndDropService('isDragging').$;

  private objectScopingService = inject(ObjectScopingService);

  constructor(
    private taskWorkspaceStore: TaskWorkspaceStore,
    private objectDragAndDropService: ObjectDragAndDropService,
    private selectionService: SelectionService,
  ) {}

  @HostListener('click')
  unscopeObject() {
    const { scopedObjectId } = this.taskWorkspaceStore.state();
    const parentId = this.objectScopingService.getParentObjectId();
    this.objectScopingService.scopeObject(parentId, 'button', 'unscope');
    this.selectionService.setSelection([scopedObjectId].filter(isDefined), []);
  }

  @HostListener('mouseenter')
  setTargetNestingObjectId() {
    if (this.objectDragAndDropService.state().isDragging) {
      this.objectDragAndDropService('targetNestingObjectId').set(
        this.objectScopingService.getParentObjectId(),
      );
    }
  }

  @HostListener('mouseleave')
  removeTargetNestingObject() {
    this.objectDragAndDropService('targetNestingObjectId').set(null);
  }
}
